// Update these values to match those of your Server URL, DriveWorks Group Alias
// and Project Name that you wish to be rendered.

const config = {
    serverUrl: "https://driveworksapi.wpshandrails.com:8024",
    groupAlias: "WPSI_Balustrades",
    projectName: "Juliet",
    // (Optional) Set Specification ping interval - in seconds
    // A Specification will timeout after a configured period of inactivity (see DriveWorksConfigUser.xml).
    // This function prevents a Specification timing out as long as the page is in view.
    // Disable the ping by changing the setting to 0
    specificationPingInterval: 60,
	// Set Complete and Cancel Pages
	completePageURL: "https://www.wpshandrails.com/pages/completed-",
	cancelPageURL: "https://www.wpshandrails.com/pages/cancelled-",
};

// Setting these will reflect the Github example codes
const SERVER_URL = config.serverUrl;
const GROUP_ALIAS = config.groupAlias;
const PROJECT_NAME = config.projectName;

// Declaring this here helps make the ID available globally / by other functions
let specificationId;

let specification;

let client;